// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29SMy","content":"styles_content__3_-B6","tableWrap":"styles_tableWrap__3qlVM"};